import React, { Fragment, useContext, useEffect } from 'react';
import SubscriptionItem from './SubscriptionItem';
import Spinner from '../layout/Spinner';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import ClientsContext from '../../context/clients/clientsContext';
import SubscriptionsContext from '../../context/subscriptions/subscriptionsContext';

const Subscriptions = () => {
  const clientsContext = useContext(ClientsContext);
  const subscriptionsContext = useContext(SubscriptionsContext);

  const clientId = clientsContext.current.id;

  const {
    subscriptions,
    filtered,
    getSubscriptions,
    loading
  } = subscriptionsContext;

  useEffect(() => {
    getSubscriptions(clientId);
    // eslint-disable-next-line
  }, [clientId]);

  // if (clients !== null && clients.length === 0 && !loading) {
  //   return <h4>Please enter a client</h4>;
  // }

  return (
    <Fragment>
      {subscriptions !== null && !loading ? (
        <TransitionGroup>
          {filtered !== null
            ? filtered.map(subscription => (
                <CSSTransition
                  key={subscription.id}
                  timeout={500}
                  classNames='item'
                >
                  <SubscriptionItem
                    subscription={subscription}
                    clientId={clientId}
                  />
                </CSSTransition>
              ))
            : subscriptions.map(subscription => (
                <CSSTransition
                  key={subscription.id}
                  timeout={500}
                  classNames='item'
                >
                  <SubscriptionItem
                    subscription={subscription}
                    clientId={clientId}
                  />
                </CSSTransition>
              ))}
        </TransitionGroup>
      ) : (
        <Spinner />
      )}
    </Fragment>
  );
};

export default Subscriptions;
